import { CoverageByHourFragment } from 'generated/resources/graphql'
import { computed, makeObservable } from 'mobx'

import Coverage from 'modules/shift_management/store/internal/models/Coverage'

class Coverages {
  coverages: Coverage[]

  constructor(coverages: Coverage[]) {
    this.coverages = coverages

    makeObservable(this, {
      _groupByDate: computed,
    })
  }

  static buildFromRequest(coverages: CoverageByHourFragment[]): Coverages {
    const coverageObjects = coverages.map((coverage) => Coverage.buildFromRequest(coverage))

    return new Coverages(coverageObjects)
  }

  get _groupByDate(): Record<string, Coverage> {
    return this.coverages.reduce((result: Record<string, Coverage>, coverage) => {
      result[coverage.date.utc().format('YYYY-MM-DD HH:mm')] = coverage
      return result
    }, {})
  }

  getNumberOfShifts(date: moment.Moment): number {
    return this._groupByDate[date.format('YYYY-MM-DD HH:mm')]?.numberOfShifts || 0
  }
}

export default Coverages
